import { render, staticRenderFns } from "./PartnersRequests.vue?vue&type=template&id=b03ded9e"
import script from "./PartnersRequests.vue?vue&type=script&lang=js"
export * from "./PartnersRequests.vue?vue&type=script&lang=js"
import style0 from "./PartnersRequests.vue?vue&type=style&index=0&id=b03ded9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports